
import { Vue, Prop, Component, Watch } from "vue-property-decorator";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import TitlesMultiselect from "@/components/autocompleteMultiselects/TitlesMultiselectNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselectV2.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import ProfileAvailabilitySelect from "@/components/autocompleteMultiselects/ProfileAvailabilitySelect.vue"
import FormGroup from "@/components/form/FormGroupNew.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCitiesMultiselectNew.vue"
import radioOptions from "@/data/filters/radioOptions";
import contractorsCollectionFiltersTemplate from "@/data/filtersTemplates/contractorsCollectionFiltersTemplate";
import RadioOption from "@/entities/RadioOption";
import DropdownOption from "@/entities/DropdownOption";
import UserAvailable from "@/entities/filters/UserAvailable";
import ContractorsCollectionFiltersQuery from "@/entities/filters/ContractorsCollectionFiltersQuery";
import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";

@Component({
  components: {
    RegionInput,
    InputRangeFilter,
    RadioButtonGroup,
    UiButton,
    FiltersContainer,
    TitlesMultiselect,
    SkillsMultiselect,
    ManagersMultiselect,
    ProjectsMultiselect,
    FormGroup,
    UiButtonMessage,
    UserCityMultiselect,
    ProfileAvailabilitySelect,
    ProfileCountrySelect,
  },
})
export default class ContractorCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
   @Prop({ type: String, required: true }) readonly parentInputClass!: string;
  @Prop({ type: Object, required: true })
  readonly filters!: ContractorsCollectionFiltersQuery;

  countries: DropdownOption[] = [];
  states: DropdownOption[] = [];
  cities: DropdownOption[] = [];
  titles: DropdownOption[] = [];
  skillsIds: number[] = [];
  projectsIds: string[] = [];
  managersIds: string[] = [];
  name: string = "";
  minRate: string = "";
  maxRate: string = "";
  available: UserAvailable = contractorsCollectionFiltersTemplate.available;

  radioOptions: RadioOption[] = radioOptions;

  get countriesNames(): string[] {
    return this.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.cities.map((city) => city.name);
  }

  get titlesNames(): string[] {
    return this.titles.map((title) => title.name);
  }

  get trimmedName(): string {
    return this.name.trim();
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.trimmedName,
      this.available,
      this.minRate,
      this.maxRate,
      this.countriesNames,
      this.statesNames,
      this.citiesNames,
      this.titlesNames,
      this.skillsIds,
      this.managersIds,
      this.projectsIds,
    ]);
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.countries = getMultiselectValues(this.filters.countries);
    this.states = getMultiselectValues(this.filters.states);
    this.cities = getMultiselectValues(this.filters.cities);
    this.titles = getMultiselectValues(this.filters.titles);
    this.skillsIds = this.filters.skills;
    this.projectsIds = this.filters.projects;
    this.managersIds = this.filters.managers;
    this.name = this.filters.name;
    this.available = this.filters.available;
    this.minRate = this.filters.minRate;
    this.maxRate = this.filters.maxRate;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      titles: this.titlesNames,
      skills: this.skillsIds,
      managers: this.managersIds,
      projects: this.projectsIds,
      name: this.trimmedName,
      available: this.available,
      minRate: this.minRate,
      maxRate: this.maxRate,
    });
  }

  handleReset(): void {
    this.$emit("resetFilters");
  }
}
